import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { NSCommons } from '@ruby/configs/common.constants';
import { NSUnitTrainDialogsConstants } from '@ruby/configs/unit-train-dialogs.constants';
import { IUTWaybillCar } from '@ruby/modules/unit-train/models/unit-train.interface';

@Component({
  selector: 'ng-cars-waybill-dialog',
  styleUrls: ['./cars-waybill.dialog.scss'],
  templateUrl: './cars-waybill.dialog.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CarsWaybillDialog {
  @Input() title = 'Waybill Inquiry';
  @Input() cars: Array<IUTWaybillCar> = [];
  @Input() loading!: boolean;
  gridConfigurations = NSUnitTrainDialogsConstants.carsWaybillGridConfigs;

  constructor() {}

  get permitName(): string {
    return this.cars.length ? `Permit ${ this.cars[0].permitNumber } ${ NSCommons.formatNSDate(this.cars[0].permitTimeStamp) }` : '';
  }
}
